import React from "react";

// Material UI Components
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";

// Components
import Five9Header from "./Five9Header";
import Five9Body from "./Five9Body";

// This component will hold the latest leads data
const Five9Table = ({ callLogs, totalCallLogs, open }) => {
  return (
    <div className={`${open ? "show-table" : "hide-table"}`}>
      <h4 className="aggregated-report-count">Total Logs {totalCallLogs}</h4>
      <TableContainer>
        <Table className="table">
          <Five9Header />
          <Five9Body callLogs={callLogs} />
        </Table>
      </TableContainer>
      <div className="bottom-footer"></div>
    </div>
  );
};

export default Five9Table;
